<template>
  <div>
    <i-dropdown>
      <template v-slot:trigger="{toggle, attrs}">
        <i-button variant="simple" :title="LANG.moreOptionsLabel" @click="toggle" v-bind="attrs">
          <i-icon icon="ellipsis-h"></i-icon>
        </i-button>
      </template>
      <template v-slot:default="{close}">
        <i-menu-list class="pull-right">
          <i-menu-action
            :label="LANG.showDocuments"
            icon="search"
            @click.prevent.stop="() => { showRealTagInDocBrowser(tag); close(); }"
          />
          <i-menu-action
            :label="tag.recommended ? LANG.removeRecommendation : LANG.addRecommendation"
            :icon="tag.recommended ? 'times' : 'thumbtack'"
            @click.prevent.stop="() => { toggleRealmTagRecommendation(tag); close(); }"
            :enabled="checkACL('/data/ts/tag/recommend')"
          />
          <i-menu-action
            v-if="!tag.recommended"
            :label="LANG.delete"
            icon="trash"
            @click.prevent.stop="() => { deleteRealmTag(tag); close(); }"
            :enabled="!!(checkACL('/data/ts/tag/delete') && tag.deletable)"
          />
        </i-menu-list>
      </template>
    </i-dropdown>

    <i-modal :title="LANG.confirmation" v-model:show="showConfirmationModal">
      {{ LANG.confirmDeleteTag }}<br><br>{{ tag.name }}
      <template #footer>
        <i-button variant="secondary" @click.prevent="showConfirmationModal=false">{{ LANG.cancel }}</i-button>
        <i-button variant="primary"
          @click.prevent="deleteRealmTag(tag); showConfirmationModal = false;">
          {{ LANG.delete }}
        </i-button>
      </template>
    </i-modal>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';

export default {
  props: {
    tag: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      showConfirmationModal: false,
    };
  },
  methods: {
    ...mapActions('tags', [
      'deleteRealmTag',
      'showRealTagInDocBrowser',
      'toggleRealmTagRecommendation',
    ]),
  },
  computed: {
    ...mapState(['LANG']),
    ...mapGetters(['checkACL']),
  },
};
</script>

<style scoped lang='scss'>
  .i-button.i-simple-btn.active::v-deep {
    background: $i-list-selected-bg;
  }
</style>
